module.exports = __webpack_public_path__ + "static/media/3.87a9126d.svg";